// src/utils/breakpoints.js
export const sizes = {
  mobile: 768,
  tablet: 992,
  desktop: 1200,
}
